import { render, staticRenderFns } from "./VCostsDetailedBudgetReport.vue?vue&type=template&id=7a65d413&"
import script from "./VCostsDetailedBudgetReport.vue?vue&type=script&lang=js&"
export * from "./VCostsDetailedBudgetReport.vue?vue&type=script&lang=js&"
import style0 from "./VCostsDetailedBudgetReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports